
import React, { useEffect, useState } from 'react';
 import {Link} from 'react-router-dom'
// Assuming you have equivalent functions for Firebase data fetching in React
import { getAuthor } from '../lib/firebase/author/read_server';  // Adjust paths if needed
import { getCategory } from '../lib/firebase/category/read_server';  // Adjust paths if needed
import { getAllPosts } from '../lib/firebase/post/read_server'; 

export default function PostListView() {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    async function fetchPosts() {
      const fetchedPosts = await getAllPosts();
      setPosts(fetchedPosts);
    }
    fetchPosts();
  }, []);

  if (!posts || posts.length === 0) {
    return (
      <div>
        <h3>Posts Not Available!</h3>
      </div>
    );
  }

  return (
    <section className="p-3">
      <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-5 g-4">
        {posts.map((post, index) => {
          return <PostCard post={post} key={index} />;
        })}
      </div>
    </section>
  );
}

function PostCard({ post }) {
  return (
    <Link to={`/posts/${post?.id}`} className="col" style={{textDecoration:"none"}}>
      <div className="card p-3 rounded-3">
        <div className="position-relative">
          <div className="position-absolute top-0 end-0 p-1">
            <CategoryCard categoryId={post?.categoryId} />
          </div>
          <img
            className="card-img-top h-200px"
            src={post?.imageURL}
            alt="Post"
          />
        </div>
        <div className="card-body p-2">
          <h5 className="card-title font-weight-bold mb-2">{post?.title}</h5>
          <div className="d-flex justify-content-between">
            <AuthorCard authorId={post?.authorId} />
            <p className="text-muted fw-bold mb-0">
              {post?.timestamp?.toDate()?.toLocaleDateString()}
            </p>
          </div>
        </div>
      </div>
    </Link>
  );
}

function AuthorCard({ authorId }) {
  const [author, setAuthor] = useState(null);

  useEffect(() => {
    async function fetchAuthor() {
      const fetchedAuthor = await getAuthor(authorId);
      setAuthor(fetchedAuthor);
    }
    fetchAuthor();
  }, [authorId]);

  return (
    <div className="d-flex gap-2 align-items-center">
      <img
        className="rounded-circle border border-1 border-dark"
        style={{ width: "30px", height: "30px" }}
        src={author?.photoURL}
        alt="Author"
      />
      <p className="text-muted mb-0">{author?.name}</p>
    </div>
  );
}

function CategoryCard({ categoryId }) {
  const [category, setCategory] = useState(null);

  useEffect(() => {
    async function fetchCategory() {
      const fetchedCategory = await getCategory(categoryId);
      setCategory(fetchedCategory);
    }
    fetchCategory();
  }, [categoryId]);

  return (
    <div className="d-flex gap-2 align-items-center bg-light rounded-pill px-2 py-1">
      <img className="rounded-circle" style={{ width: '30px', height: '30px' }} src={category?.iconURL} alt="Category" />
      <p className="text-muted mb-0 text-center">{category?.name}</p>
    </div>
  );
}
